const STORAGE_KEY = 'safeguardpro_email_log';

const readLogs = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeLogs = (logs) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
};

export default class EmailLogService {
  list() {
    return readLogs();
  }

  add(entry) {
    const logs = readLogs();
    const next = [
      {
        id: entry.id || `email-${Math.random().toString(36).slice(2, 8)}`,
        created_at: entry.created_at || new Date().toISOString(),
        status: entry.status || 'queued',
        ...entry
      },
      ...logs
    ];
    writeLogs(next.slice(0, 500));
    return next[0];
  }
}
